<div class="main-wrapper-section">
    <div class="common-header">
        <h3>Contract Settings</h3>
    </div>
    <div class="card-section">
        <!--<form [formGroup]="siteForm">-->
        <div class="card-panel margin-top20">
            <h6>Accepted Payment Methods</h6>
            <hr />
            <form [formGroup]="configForm" (ngSubmit)="saveContractSetting()">
                <div class="payment-grid">
                    <table class="table">
                        <thead>
                            <tr>
                                <th style="width:10%"></th>
                                <th [ngClass]="form.isEntryCC.value && form.isEntryACH.value ? 'contract-settings-fees' : 'contract-settings-no-fees'">Non-Recurring Fees</th>
                                <th style="width:20%" *ngIf="form.isEntryCC.value && form.isEntryACH.value">CC Fee (NR)</th>
                                <th [ngClass]="form.isMonthlyCC.value && form.isMonthlyACH.value ? 'contract-settings-fees' : 'contract-settings-no-fees'">Recurring Fees</th>
                                <th style="width:20%" *ngIf="form.isMonthlyCC.value && form.isMonthlyACH.value">CC Fee (R)</th>
                                <th>Payment Templates</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td><b>Credit Card</b></td>
                                <td>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isEntryCC" formControlName="isEntryCC">
                                        <label class="custom-control-label" for="isEntryCC"></label>
                                    </div>
                                </td>
                                <td *ngIf="form.isEntryCC.value && form.isEntryACH.value">
                                    <div class="" style="margin: 0 auto;">
                                        <input class="form-control contract-settings-input-fee" type="text" formControlName="ccNRFee" maxlength="6" />
                                        <div class="custom-control custom-switch contract-settings-cc-fee">
                                            <input type="checkbox" class="custom-control-input" id="ccNRFeeIsPercent" formControlName="ccNRFeeIsPercent">
                                            <label class="custom-control-label" for="ccNRFeeIsPercent">Percent</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isMonthlyCC" formControlName="isMonthlyCC">
                                        <label class="custom-control-label" for="isMonthlyCC"></label>
                                    </div>
                                </td>
                                <td *ngIf="form.isMonthlyCC.value && form.isMonthlyACH.value">
                                    <div class="" style="margin: 0 auto;">
                                        <input class="form-control contract-settings-input-fee" type="text" formControlName="ccRFee" maxlength="6" />
                                        <div class="custom-control custom-switch contract-settings-cc-fee">
                                            <input type="checkbox" class="custom-control-input" id="ccRFeeIsPercent" formControlName="ccRFeeIsPercent">
                                            <label class="custom-control-label" for="ccRFeeIsPercent">Percent</label>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <div class="custom-control">
                                        <kendo-combobox class="form-control" [data]="mailMergeTempList"
                                                        [valuePrimitive]="true"
                                                        textField="text"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        formControlName="CCAuthMMID"
                                                        valueField="id">
                                        </kendo-combobox>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="(form.isEntryCC.value && form.isEntryACH.value) || (form.isMonthlyCC.value && form.isMonthlyACH.value)">
                                <td></td>
                                <td>
                                </td>
                                <td *ngIf="form.isEntryCC.value && form.isEntryACH.value">
                                    <div class="" style="">
                                        <textarea type="text" rows="5" formControlName="ccNRFeeDisclaimer" class="form-control" maxlength="500" placeholder="Disclaimer: Please note, a surcharge of 3% applies to fees paid by credit card."></textarea>
                                    </div>
                                </td>
                                <td>
                                </td>
                                <td *ngIf="form.isMonthlyCC.value && form.isMonthlyACH.value">
                                    <div class="" style="">
                                        <textarea type="text" rows="5" formControlName="ccRFeeDisclaimer" class="form-control" maxlength="500" placeholder="Disclaimer: Please note, a surcharge of $10 applies to fees paid by credit card."></textarea>
                                    </div>
                                </td>
                                <td>
                                </td>
                            </tr>
                            <tr>
                                <td><b>ACH</b></td>
                                <td>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isEntryACH" formControlName="isEntryACH">
                                        <label class="custom-control-label" for="isEntryACH"></label>
                                    </div>
                                </td>
                                <td *ngIf="form.isEntryCC.value && form.isEntryACH.value">
                                </td>
                                <td>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isMonthlyACH" formControlName="isMonthlyACH">
                                        <label class="custom-control-label" for="isMonthlyACH"></label>
                                    </div>
                                </td>
                                <td *ngIf="form.isMonthlyCC.value && form.isMonthlyACH.value">
                                </td>
                                <td>
                                    <div class="custom-control">
                                        <kendo-combobox class="form-control" [data]="mailMergeTempList"
                                                        [valuePrimitive]="true"
                                                        textField="text"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        formControlName="ACHAuthMMID"
                                                        valueField="id">
                                        </kendo-combobox>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><b>Physical Check</b></td>
                                <td>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isEntryCheck" formControlName="isEntryCheck">
                                        <label class="custom-control-label" for="isEntryCheck"></label>
                                    </div>
                                </td>
                                <td *ngIf="form.isEntryCC.value && form.isEntryACH.value">
                                </td>
                                <td>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isMonthlyCheck" formControlName="isMonthlyCheck">
                                        <label class="custom-control-label" for="isMonthlyCheck"></label>
                                    </div>
                                </td>
                                <td *ngIf="form.isMonthlyCC.value && form.isMonthlyACH.value">
                                </td>
                                <td>
                                    <div class="custom-control">
                                        <kendo-combobox class="form-control" [data]="mailMergeTempList"
                                                        [valuePrimitive]="true"
                                                        textField="text"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        formControlName="CheckAuthMMID"
                                                        valueField="id">
                                        </kendo-combobox>
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><b>Cash</b></td>
                                <td>
                                    <div class="custom-control custom-switch">
                                        <input type="checkbox" class="custom-control-input" id="isEntryCash" formControlName="isEntryCash">
                                        <label class="custom-control-label" for="isEntryCash"></label>
                                    </div>
                                </td>
                                <td *ngIf="form.isEntryCC.value && form.isEntryACH.value">
                                </td>
                                <td>
                                </td>
                                <td *ngIf="form.isMonthlyCC.value && form.isMonthlyACH.value">
                                </td>
                                <td>
                                    <div class="custom-control">
                                        <kendo-combobox class="form-control" [data]="mailMergeTempList"
                                                        [valuePrimitive]="true"
                                                        textField="text"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        formControlName="CashAuthMMID"
                                                        valueField="id">
                                        </kendo-combobox>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="row">
                    <div class="col-lg-4 col-sm-12">
                        <h6>Contract Email to Client Template</h6>
                        <hr />
                        <div class="row margin-top10">
                            <div class="col-lg-12 col-sm-12">
                                <div>
                                    <kendo-combobox class="form-control" [data]="emailTempList"
                                                    [valuePrimitive]="true"
                                                    textField="text"
                                                    [kendoDropDownFilter]="filterSettings"
                                                    [filterable]="true"
                                                    formControlName="ContractEmailID"
                                                    valueField="id">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>

                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <h6>Driver's License Template</h6>
                        <hr />
                        <div class="row margin-top10">
                            <div class="col-lg-12 col-sm-12">
                                <div>
                                    <kendo-combobox class="form-control" [data]="mailMergeTempList"
                                                    [valuePrimitive]="true"
                                                    textField="text"
                                                    [kendoDropDownFilter]="filterSettings"
                                                    [filterable]="true"
                                                    formControlName="dLMMID"
                                                    valueField="id">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-lg-4 col-sm-12">
                        <h6>Contract Ready to be Counter-Signed Template</h6>
                        <hr />
                        <div class="row margin-top10">
                            <div class="col-lg-12 col-sm-12">
                                <div>
                                    <kendo-combobox class="form-control" [data]="emailTempList"
                                                    [valuePrimitive]="true"
                                                    textField="text"
                                                    [kendoDropDownFilter]="filterSettings"
                                                    [filterable]="true"
                                                    formControlName="signOffID"
                                                    valueField="id">
                                    </kendo-combobox>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-lg-4 col-sm-12">
                        <div class="margin-top10">
                            <h6>Contract Ready to be Audited Template</h6>
                            <hr />
                            <div class="row margin-top10">
                                <div class="col-lg-12 col-sm-12">
                                    <div>
                                        <kendo-combobox class="form-control" [data]="emailTempList"
                                                        [valuePrimitive]="true"
                                                        textField="text"
                                                        [kendoDropDownFilter]="filterSettings"
                                                        [filterable]="true"
                                                        formControlName="contractAuditorID"
                                                        valueField="id">
                                        </kendo-combobox>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="button-group margin-top10">
                    <div class="form-group">
                        <button class="primary-btn" type="submit">Save</button>
                    </div>
                </div>
            </form>
        </div>
    </div>
</div>

